import React from "react";
import { useSelector } from "react-redux";
import Carousel_1 from "../../../imgs/carousel_home/carousel_1.jpg";
import Carousel_2 from "../../../imgs/carousel_home/carousel_2.jpg";
import Carousel_2_1 from "../../../imgs/carousel_home/carousel_2_1.jpg";
import Carousel_3 from "../../../imgs/carousel_home/carousel_3.jpg";
import Carousel_4 from "../../../imgs/carousel_home/carousel_4.jpg";
import CarouselBtn from "../../BTN/carouselBtn";
import "../../../styles/carousel.css";
import { withNamespaces } from 'react-i18next';

const Caroussel = ({ t }) => {

  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide homeCarousel"
      data-bs-ride="carousel"
    >
      <ol className="carousel-indicators">
        <li
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          className="active"
        ></li>
        <li
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
        ></li>
        <li
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
        ></li>
        <li
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="3"
        ></li>
      </ol>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src={Carousel_1}
            className="d-block w-100 sizeIMG"
            alt="First slide"
          />
          <div className="container">
            <div className="carousel-caption d-sm-block">
              <h1 className="text-start">{t('moduleHomepage:C.C1')}</h1>
              <CarouselBtn
                link="/estudarua"
                title={t('moduleBotoes:B1.Title.B1')}
                texto={t('moduleBotoes:B1.B')}
              />
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src={Carousel_2_1}
            className="d-block w-100 sizeIMG"
            alt="Second slide"
          />
          <div className="container">
            <div className="carousel-caption d-md-block">
              <h1 className="text-start">{t('moduleHomepage:C.C2')}</h1>
              <CarouselBtn
                link="/todolist#start"
                title={t('moduleBotoes:B1.Title.B2')}
                texto={t('moduleBotoes:B1.B')}
              />
            </div>
          </div>
        </div>

        <div className="carousel-item">
          <img
            src={Carousel_3}
            className="d-block w-100 sizeIMG"
            alt="Third slide"
          />
          <div className="container">
            <div className="carousel-caption d-md-block">
              <h1 className="text-start">{t('moduleHomepage:C.C3')}</h1>
              <CarouselBtn
                link="/cidadeaveiro"
                title={t('moduleBotoes:B1.Title.B3')}
                texto={t('moduleBotoes:B1.B')}
              />
            </div>
          </div>
        </div>

        <div className="carousel-item">
          <img
            src={Carousel_4}
            className="d-block w-100 sizeIMG"
            alt="Fourth slide"
          />
          <div className="container">
            <div className="carousel-caption d-md-block">
              <h1 className="text-start">{t('moduleHomepage:C.C4')}</h1>
              <CarouselBtn
                link="/vidaacademica"
                title={t('moduleBotoes:B1.Title.B4')}
                texto={t('moduleBotoes:B1.B')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(Caroussel);
